import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HdTipComponent } from './hd-tip.component';
import {NgZorroAntdModule} from 'ng-zorro-antd';

@NgModule({
  imports: [
    CommonModule,
    NgZorroAntdModule
  ],
  exports: [HdTipComponent],
  declarations: [HdTipComponent]
})
export class HdTipModule { }
